import type { QuestionCommentModelData, SurveyAnswerValue } from '@coorum-research/shared-common/types'
import type { SurveyElementForm } from './survey-element-form'
import { useMemo, useState } from 'react'
import { cn } from '../../utils'
import { useTheme } from '../ThemeContext'
import { ElementHeader } from './ElementHeader'
import { ElementValidationMessage } from './ElementValidationMessage'
import { SurveyElementLayout } from './SurveyElementLayout'

type Props = {
  currentForm: SurveyElementForm
  validationError: string | null
  onValueChange?: (value: SurveyAnswerValue) => void
  isPanelQuestion?: boolean
}

export function SurveyElementComment({
  currentForm,
  validationError,
  onValueChange,
  isPanelQuestion = false,
}: Props) {
  const themeJson = useTheme()
  const currentElement = currentForm.elementJson as QuestionCommentModelData
  const initialValue = useMemo(() => currentForm.getValue() as string, [currentForm])
  const [value, setValue] = useState<string>(initialValue)

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value
    setValue(newValue)
    currentForm.setElementResultRecordValue(newValue)
    onValueChange?.(newValue)
  }

  return (
    <SurveyElementLayout isPanelQuestion={isPanelQuestion}>
      <ElementValidationMessage
        validationError={validationError}
      />
      <ElementHeader
        currentElement={currentElement}
      />
      <div
        style={{
          color: themeJson?.mainTextColor,
        }}
      >
        <textarea
          className={cn(
            'w-full',
            'shadow-[0px_0px_0px_1px_#909190]',
            'focus:outline-none focus:ring-[2px] focus:ring-[var(--theme-outline-color)] focus:border-[var(--theme-outline-color)]',
            'transition-all duration-200',
            'p-3 px-4',
            'rounded',
          )}
          style={{
            color: themeJson?.mainTextColor,
          }}
          value={value}
          onChange={handleChange}
          placeholder={currentElement.placeholder}
          rows={4}
        />
      </div>
    </SurveyElementLayout>
  )
}
